import React, { useState } from 'react'
import {v4 } from "uuid"
import {IoMdAdd} from "react-icons/io"
import {FiMinus} from "react-icons/fi"
import {AiOutlineDown, AiOutlineRight} from "react-icons/ai"
import styles from "./experience.module.css"
import { updatePost } from '../../utils/Fetch/fetch'
import { toast } from 'react-toastify'
import Loader from '../Loader/loader'

const month = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const Experience = () => {

    const [inputFields, setInputFields] = useState([
        {companyName : "", role : "", from : "", to : "", check:false, id: v4()}
    ])
    const [color, setColor] = useState(false)
    const [show, setShow] = useState(false)
        const [showLoader, setShowLoader] = useState(false);

    const handleChangeInput = (id, event) => {
        console.log(typeof event.target.checked)
        let newInputs;
        if(event.target.type === "checkbox") {
            console.log("insode check")
            newInputs = inputFields.map((el) => {
                if(id === el.id) {
                    el[event.target.name] = event.target.checked;
                }
                return el
            })
        }
        // else if(event.target.type === "month"){

        //  newInputs = inputFields.map((el) => {
        //     if(id === el.id) {
        //         el[event.target.name] =   month[event.target.value.split("-")[1][1]];
        //     }
        //     return el
        // })
        // }
        else {
            newInputs = inputFields.map((el) => {
                if(id === el.id) {
                    el[event.target.name] = event.target.value;
                }
                return el
            })
        }

        setInputFields(newInputs)
        console.log(inputFields)
    }
    const handleAddInput = () => {
        if(inputFields.length > 1){
            toast("Sorry! only latest 2 experience are allowed")
            return;
        }
        setInputFields([...inputFields, {companyName : "", role : "", from : "", to : "", check: false, id: v4()}])
    }
    const handleMinusInput = (index) => {
        const values  = [...inputFields];
        values.splice(index, 1)
        setInputFields(values)
    }

    const handleSave = async ()=> {
      setShowLoader(true);
        let flag = false
        inputFields.forEach((el) => {
          if(el.companyName==="" || el.role==="" || el.from===""){
            flag = true;
          }
          if(el.to === "" && el.check===false){
            flag=true
          }
        })


        if(flag){
          alert("Please fill the empty technical skills")
          setColor(false)
          setShowLoader(false);
          return;
        }
        let payload = inputFields.map((el) => {
          return {companyName : el.companyName, role: el.role, from: `${month[el.from.split("-")[1][1]]} ${el.from.split("-")[0]}`, to:el.check===true?"Present":`${month[el.to.split("-")[1][1]]} ${el.to.split("-")[0]}`}
        })
        const updatedata = async () => {
          let data = await updatePost(JSON.stringify({experience: payload}))
          return data;
        }
  
        let updatedData = await updatedata()
  
        if(updatedData.success===true){
          toast("Experience data is saved successfully!")
          setColor(true)
          setShow(false)
          setShowLoader(false);
        }else {
          toast("Something went wrong!")
          setShowLoader(false);
        }
  
  
  
      }

  return (
    <div>
        <nav className={styles.profile__nav} onClick={() => setShow(!show)}>
        <h3 style={{color : color===false ? "crimson" : 'grey'}}>
          Experience (optional)</h3>
        <span>
          {show ? <span className={styles.updown__icon}><AiOutlineDown/></span> : <span className={styles.updown__icon}><AiOutlineRight/></span>}
        </span>
      </nav>
      {
            show && <div className={styles.input__box}>
        {
            inputFields.map((input, index) => (
                <div key={input.id} className={styles.inputs}>

                <div>
                <label htmlFor="companyName">Company Name</label>
                <input type="text"name='companyName'id="companyName" value={input.companyName} placeholder="company name" 
                onChange={(event) => handleChangeInput(input.id, event)}/>
                </div>

                <div>
                <label htmlFor="role">Role</label>
                <input type="text" name='role' id="role"value={input.role} placeholder="role"
                onChange={(event) => handleChangeInput(input.id, event)}/>
                </div>

                <div>
                <label htmlFor='from'>Start Date</label>
                <input type="month" id="from" name="from"  placeholder="Start date" 
                onChange={(event) => handleChangeInput(input.id, event)} value={input.from}/>
                </div>

                {
                    input.check===false && <div> 
                    <label htmlFor="to">End Date</label>
                    <input type="month" name='to' id="to" value={input.to} placeholder="End date"
                    onChange={(event) => handleChangeInput(input.id, event)}/>
                    </div>
                }

                <div>
                <label>Currently working</label>
                <input type="checkbox" value={input.check} name="check"  onChange={(event) => handleChangeInput(input.id, event)}/>
                </div>

                <div>
                <button onClick={() => handleAddInput()}>
                <IoMdAdd />
                </button>
                {
                    index >= 1 && <button style={{marginLeft:"5px"}} onClick={() => handleMinusInput(index)}>
                        <FiMinus />
                    </button>
                }
                </div>

                </div>
            ))
        }
            <div className={styles.savebtn_box}>
                <button onClick={handleSave}>Save</button>
            </div>
        </div>
      }
{showLoader && <Loader /> }
    </div>
  )
}

export default Experience